/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { apiUpdatePwd } from '@/api';
export default {
  data: function data() {
    return {
      inputType: 'text',
      pwd: '',
      newPwd: '',
      pwdAgain: ''
    };
  },
  methods: {
    changeInputType: function changeInputType() {
      this.inputType = 'password';
    },
    onConfirm: function onConfirm() {
      var _this = this;
      var that = this;
      this.formValidate().then(function (valid) {
        if (valid.success) {
          that.modifyPwd();
        } else {
          _this.$vux.toast.text(valid.msg);
        }
      });
    },
    formValidate: function formValidate() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        if (_this2.pwd === '') resolve({
          success: false,
          msg: i18n.tc("174")
        });
        if (_this2.newPwd === '') resolve({
          success: false,
          msg: i18n.tc("501")
        });
        if (_this2.pwdAgain === '' || _this2.pwdAgain !== _this2.newPwd) resolve({
          success: false,
          msg: i18n.tc("502")
        });
        resolve({
          success: true
        });
      });
    },
    modifyPwd: function modifyPwd() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apiUpdatePwd({
                  old_password: _this3.pwd,
                  password: _this3.newPwd
                });
              case 2:
                res = _context.sent;
                if (res.success) {
                  _this3.$vux.toast.text(i18n.tc("484"));
                  _this3.$router.go(-1);
                } else {
                  _this3.$vux.toast.text(res.message);
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};